import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {BobcardEventTypes} from "./Events";

export enum BobcardEventContainerTypes {
    Journeys = "9eadb775-a15f-4d0c-b069-bc142d3925e1",
}

export const bobcardEventContainerTypeByEventType: Record<BobcardEventTypes, BobcardEventContainerTypes> = {
    [BobcardEventTypes.call]: BobcardEventContainerTypes.Journeys,
    [BobcardEventTypes.applicationsInitiated]: BobcardEventContainerTypes.Journeys,
};

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const BOBCARD__EVENT_CONTAINER__LEADS__DISPOSITION__COLUMN_ID = "98140329-3e97-4f83-bcf9-565b83d64c4c" as Uuid;

export const BOBCARD__EVENT_CONTAINER__LEADS__ORGANIZATIONAL_UNIT__COLUMN_ID = "0d1f665f-91d6-4ba9-86c7-32ec85b9a468" as Uuid;

export const BOBCARD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID = "931227a4-176d-4e1f-a5ca-a47146d0b27a" as Uuid;

export const BOBCARD__EVENT_CONTAINER__FIRST_NAME__COLUMN_ID = "52f890d6-38e9-4414-bd5a-e6a606e76812" as Uuid;

export const BOBCARD__EVENT_CONTAINER__LAST_NAME__COLUMN_ID = "276dbfad-2f25-45fb-9a6b-a5c62b0c1064" as Uuid;

export const BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID = "a71e8f2a-7b91-4d3c-9e04-52a8f1c3d701" as Uuid;

export const BOBCARD__EVENT_CONTAINER__REJECTION_STAGE__COLUMN_ID = "b82f903b-8c02-4e4d-af15-63b9f2d4e812" as Uuid;

export const BOBCARD__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID = "400c4781-a5a8-4411-a04a-d1d0f283120d" as Uuid;

export const BOBCARD__EVENT_CONTAINER__STATUS__COLUMN_ID = "b60fc4ae-901e-4cf0-be92-03aef7a457f9" as Uuid;

export const BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID = "ca124051-8d2a-4673-b6d3-47417ff6bb24" as Uuid;

export const BOBCARD__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID = "cb1bf684-54f8-4b53-b42a-eb4a85b378f3" as Uuid;

export const BOBCARD__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID = "c3822779-1eea-4c8d-a475-c371f8edb073" as Uuid;

export const BOBCARD__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID = "87cbf261-c8fb-490e-9673-c0e1f8f15776" as Uuid;

export const BOBCARD__EVENT_CONTAINER__REMARKS_RECENT__COLUMN_ID = "0094c17f-d07d-4110-9b80-432edf6dc119" as Uuid;

export const BOBCARD__EVENT_CONTAINER__LEAD_OWNER__COLUMN_ID = "a0fd9549-4b6e-49b0-8a8d-964033faf046" as Uuid;

export const BOBCARD__EVENT_CONTAINER__ASSIGNED_ON__COLUMN_ID = "a26918aa-d95b-43f2-9ae6-57a5313d75f1" as Uuid;

export const BOBCARD__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID = "d63c67c9-1009-474e-96a3-8f67e6a73016" as Uuid;

export const BOBCARD__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID = "312493fc-b3da-46c3-9a53-3fc03bb93da6" as Uuid;

export const BOBCARD__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID = "61efb7e8-a00a-438d-bacd-39d6fbff07c9" as Uuid;

export const BOBCARD__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID = "c3aae0cc-c669-4ea3-ade7-26d43d86212a" as Uuid;

export const BOBCARD__EVENT_CONTAINER__UTM_TERM__COLUMN_ID = "73dc8ab4-410d-4401-876f-0fdf18ac829c" as Uuid;

export const BOBCARD__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID = "d5db54ad-edfc-44fd-a248-bf6af6f15f81" as Uuid;

export const BOBCARD__EVENT_CONTAINER__FBCLID__COLUMN_ID = "98ac598e-1a3b-4972-9cf7-1e2ccb8f7dd9" as Uuid;

export const BOBCARD__EVENT_CONTAINER__GCLID__COLUMN_ID = "62d71a2d-a9e9-4255-839f-a11bed7ed018" as Uuid;

export const BOBCARD__EVENT_CONTAINER__REFERRER__COLUMN_ID = "7f2a9c1e-3b4d-4e8a-9f2c-1a2b3c4d5e6f" as Uuid;

export const BOBCARD__EVENT_CONTAINER__DATE_OF_BIRTH__COLUMN_ID = "a9778b20-0651-49c1-9960-b44cd3518e24" as Uuid;

export const BOBCARD__EVENT_CONTAINER__APPLICATION_ID__COLUMN_ID = "2e71d355-54cb-4dc0-b264-d08f30360fc5" as Uuid;

export const BOBCARD__EVENT_CONTAINER__ALIAS_ID__COLUMN_ID = "6a8cd743-e3c1-4c35-b1ad-ed33fe80f971" as Uuid;

export const BOBCARD__EVENT_CONTAINER__EMPLOYMENT_STATUS__COLUMN_ID = "b846f570-8ffa-46f5-9992-f77342d48dbf" as Uuid;

export const BOBCARD__EVENT_CONTAINER__NET_MONTHLY_INCOME_NET_ANNUAL__COLUMN_ID = "fe3f6698-a380-4f34-9b74-28bff15909b7" as Uuid;

export const BOBCARD__EVENT_CONTAINER__CURRENT_PINCODE__COLUMN_ID = "f6f0e64b-3150-462f-a9ba-bcca11cd1f1a" as Uuid;

export const BOBCARD__EVENT_CONTAINER__GENDER__COLUMN_ID = "de078553-b890-45be-b61f-1065e02809d6" as Uuid;

export const BOBCARD__EVENT_CONTAINER__MARITAL_STATUS__COLUMN_ID = "ccd3771d-764c-4dc5-ad30-cdfd3a9da619" as Uuid;

export const BOBCARD__EVENT_CONTAINER__EMAIL_ADDRESS__COLUMN_ID = "da4b2d89-a478-4390-871e-ef5340f80e69" as Uuid;

export const BOBCARD__EVENT_CONTAINER__PAN_NUMBER__COLUMN_ID = "20888f0b-5b5b-4c2c-bc0d-7ebe51efd11d" as Uuid;

export const BOBCARD__EVENT_CONTAINER__COMPANY_NAME__COLUMN_ID = "2126ee01-5f2a-421b-996f-784ec4db53b3" as Uuid;

export const BOBCARD__EVENT_CONTAINER__COMPANY_ADDRESS__COLUMN_ID = "4bcfa733-06c0-41a7-b500-2b7b6ac27d7f" as Uuid;

export const BOBCARD__EVENT_CONTAINER__PERMANENT_ADDRESS__COLUMN_ID = "d4851ca8-cdc7-43cf-a6df-bcb8a7c15636" as Uuid;

export const BOBCARD__EVENT_CONTAINER__CURRENT_ADDRESS__COLUMN_ID = "65306538-e3b5-47e0-82a8-0d90389d1ab1" as Uuid;

export const BOBCARD__EVENT_CONTAINER__PAN_VALIDATION__COLUMN_ID = "392b46f6-2260-4f36-98b0-84c94ed30a82" as Uuid;

export const BOBCARD__EVENT_CONTAINER__CREDIT_HISTORY__COLUMN_ID = "73a640ea-c84a-47f0-9ee7-d3929e76986b" as Uuid;

export const BOBCARD__EVENT_CONTAINER__CREDIT_SCORE__COLUMN_ID = "53aeafd8-2d60-490b-b687-2dda0883ff82" as Uuid;

export const BOBCARD__EVENT_CONTAINER__AADHAR_NUMBER__COLUMN_ID = "b489c4d2-40de-44f7-b22a-860bdb3c8486" as Uuid;

export const BOBCARD__EVENT_CONTAINER__AADHAR_VERIFICATION__COLUMN_ID = "89f814dd-b2d3-4da1-a230-8c2a4e494cc0" as Uuid;

export const BOBCARD__EVENT_CONTAINER__NETWORK_SELECTED__COLUMN_ID = "4aa6f263-5cfb-4956-8eef-0d6c7784086a" as Uuid;

export const BOBCARD__EVENT_CONTAINER__E_CONSENT__COLUMN_ID = "2f401304-5ff6-4e34-a474-e24da3f53614" as Uuid;

export const BOBCARD__EVENT_CONTAINER__V_KYC_SUCCESSFUL__COLUMN_ID = "03e34013-799b-4723-ac57-d3e1e690ce01" as Uuid;

export const BOBCARD__EVENT_CONTAINER__UPI_LINKAGE__COLUMN_ID = "154212d7-efd9-4e41-becb-b4a9f59ac6bb" as Uuid;

export const BOBCARD__EVENT_CONTAINER__INTERESTED_CARD_VARIANT__COLUMN_ID = "7d0cb1a2-2788-4c51-a709-073657973f30" as Uuid;

export const BOBCARD__EVENT_CONTAINER__SELECTED_CARD_VARIANT__COLUMN_ID = "9c5bada5-f832-491c-91db-5cb0e8b8d369" as Uuid;

export const BOBCARD__EVENT_CONTAINER__LEAD_COUNT__COLUMN_ID = "8b46064a-17a2-4b3c-9503-8a5b65b5d361" as Uuid;

export enum BobcardGenderEnum {
    MALE = "06a93ef5-ad0b-4033-bfae-52d7941f23f4",
    FEMALE = "de250511-87e2-4a58-a2f4-34113f325249",
    OTHER = "9f0f6307-e21e-4e66-b25b-688e62eaccb7",
}

export enum BobcardEventContainerDispositionEnum {
    NEW_LEAD,
    NOT_CONNECTED_NOT_REACHABLE,
    NOT_CONNECTED_DEAD_LEAD,
    CONNECTED_VALID_INTERESTED_NEEDS_INFO_BENEFITS,
    CONNECTED_VALID_INTERESTED_NEEDS_INFO_FEES,
    CONNECTED_VALID_INTERESTED_NEEDS_INFO_ELIGIBILITY,
    CONNECTED_VALID_INTERESTED_VIDEO_KYC_PENDING,
    CONNECTED_VALID_INTERESTED_DIGILOCKER_PENDING,
    CONNECTED_VALID_INTERESTED_NOT_ELIGIBLE_FOR_CARD,
    CONNECTED_VALID_INTERESTED_READY_TO_APPLY,
    CONNECTED_VALID_INTERESTED_OTHER,
    CONNECTED_VALID_NOT_INTERESTED_SAME_BANK_CARD,
    CONNECTED_VALID_NOT_INTERESTED_OTHER_BANK_CARD,
    CONNECTED_VALID_NOT_INTERESTED_NO_CREDIT_CARD,
    CONNECTED_VALID_NOT_INTERESTED_TOO_MANY_CALLS,
    CONNECTED_VALID_NOT_INTERESTED_BAD_EXPERIENCE,
    CONNECTED_VALID_NOT_INTERESTED_FEES_CONCERN,
    CONNECTED_CALL_BACK_LATER,
    CONNECTED_INVALID_DID_NOT_FILL_DEAD_LEAD,
    CONNECTED_INVALID_FILLED_BY_MISTAKE_DEAD_LEAD,
    WRONG_NUMBER,
    CONNECTED_INVALID_DID_NOT_FILL,
    CONNECTED_INVALID_FILLED_BY_MISTAKE,
}

export enum BobcardEventContainerStatusEnum {
    LIVE = "270d1a3b-a8fd-4152-ad71-8845c0dcf697",
    CHURNED = "6971b4a9-f78b-437b-9879-6a25719ee4c5",
    ARCHIVE = "5ee83c68-555a-4377-b93d-ca60b3af2344",
}

export enum BobcardApplicationStatusEnum {
    NOT_STARTED = "4bd3ff3b-6148-4e8d-b2d6-4ee6acd89f8a",
    IN_PROGRESS = "c8ecbd91-e2b8-4d87-b7e1-af1c6d0e5042",
    ON_HOLD = "3f238326-f0a1-4f68-a2f8-263fcf16ad17",
    REJECTED = "10e39f20-c347-4f1a-b48f-c6f1b7c1b42f",
    ONBOARDED = "d7ff18da-529f-4d85-9f7e-26afdb5f8797",
    CHURNED = "4b2e4dd3-a1e6-4497-bf78-3676d9a8e0fd",
}

export enum BobcardApplicationStageEnum {
    CARD_APPROVED = "cd484ef2-0a7c-4e52-a434-a4a2ff0fa360",
    CARD_CONFIGURATION = "26baee5b-357e-4c6e-af8e-3183a0413c32",
    APPLICATION_REJECTED = "d45ff31c-0ac2-4762-abe1-875f3ef4a5cd",
    APPLICATION_APPROVED = "f5361bc8-af55-453e-ab13-88a7a9fc11c7",
    APPLICATION_HOLD = "459a4138-595c-4520-8ab0-42d05317e4c4",
    CAF_PERSONAL_DETAILS = "21f90248-5599-4294-a415-4c7b73f909a1",
    CAF_EMAIL = "076f6f1e-20c0-4517-ab9c-9dc9f9cfebea",
    CUSTOMER_DEDUPE = "bd1f7a32-cb96-45a5-b6d0-285d851dc007",
    PROGRAM_CONSENTS = "5a536219-5692-42fe-81ea-b99ada561d9e",
    PAN_VALIDATION = "4b94da8e-43fe-42ad-b5af-574fe06d0cb3",
    PAN_VERIFY_SUCCESS = "faf97f22-c819-4a07-ae72-2c0b54083a78",
    AADHAAR_VALIDATION = "5b668cd4-31e7-4ed2-976c-b505c02ee9e2",
    RE_AADHAAR_VALIDATION = "0c69302c-c649-4d16-aab3-b32beb281b3e",
    AADHAAR_VERIFY_SUCCESS = "93082839-e2cd-4f44-ad87-709167db3fba",
    CAF_PERMANENT_ADDRESS = "26368be5-c5de-40cf-bca1-fff21f3a9183",
    CAF_CURRENT_ADDRESS = "3614347d-9cea-4da9-8489-52539dfe1ed9",
    CAF_ADDITIONAL_DETAILS = "22d19272-d868-4a2f-bf13-08a68148181a",
    CAF_MOBILE_NUMBER = "25c6f557-bd10-4d63-9492-5c1123500f15",
    UPDATE_BULK_ADDRESS = "e23f52df-2aae-47b8-a5b7-c94186f20123",
    LIMIT_ENHANCEMENT = "78a82529-405a-4549-9c2d-07c76659818a",
    LIMIT_ENHANCEMENT_AA = "89b46a48-65e9-4923-9895-9c91b1d35e74",
    EMPLOYER_ADDRESS = "a38f4f1e-b359-4e58-887b-fb7ae22a846b",
    UNDERWRITING = "11f7b7b4-9830-4783-981c-88c97dc9aeaa",
    AA_UNDERWRITING = "fcf28503-2dcf-4f73-ac5d-fd6b89db97b1",
    FETCH_CREDIT_BUREAU = "2296975b-7889-48b0-9f84-3eef879cdd2c",
    ACCOUNT_AGGREGATOR = "18de804e-878f-4971-a4b9-68c69bafa724",
    OFFER_CREATED = "d35fa98d-2cf9-4da0-9785-cf71dba2c577",
    CARD_SELECTION = "8fcde814-6a33-42f2-9195-7e4da700b24a",
    CARD_DETAILS = "918c7111-8fa9-45fd-b931-38d35285aa4e",
    VIDEO_KYC = "0419c1f6-dd0b-474b-b5a9-0cf9c288ad33",
    E_SIGN_CONSENT_COMPLETED = "819be85c-997b-4db6-91fd-81fd6cdb37de",
    GENERATE_CAF_DOCUMENT = "e0eed5f8-dfde-4b2c-a3b2-8d7852bd2b15",
    AGREEMENT_SIGNED = "0f517f2b-aefd-4cc7-afa5-4c9ffaa0f3de",
    E_SIGN_AGREEMENT = "c36625c5-071b-4ffd-88ac-6c9286bf3480",
    E_SIGN_CONSENT = "fbe1d00b-ffe6-4a6f-b12f-e28efa5a3ae0",
    VKYC_FINAL_VERIFICATION = "d25a5606-834d-428d-9a67-3c6e7d16abf2",
    LP_LEAD_CREATED = "7a417b32-fa82-463a-b324-c4bf6357ac8d",
    LP_OTP_VERIFIED = "1e8448c9-b5d3-4c15-af4c-083e94013c12",
}

export enum BobcardRejectionStageEnum {
    DEDUPE_FAILED = "869077a2-f2a6-4da2-a40d-633ccaf68c02",
    INITIAL_REJECT = "1a7e52e0-9e9d-47dd-8ab3-5476bbaa3f33",
    PAN_VERIFICATION_REJECT = "32b9ce0a-4297-4afd-90d1-bf1d49021302",
    AADHAR_VERIFICATION_REJECT = "b543dea8-3fff-4589-85d2-2d7e95e3e3c5",
    UNDERWRITING_REJECT = "1f35fba1-a430-4a78-a918-a765fdf816c1",
    VKYC_REJECT = "57849485-dbe4-4c03-9025-b29f78d0ca84",
    CARD_ISSUANCE_PRECHECK = "7f8a21c6-9ce2-44ca-8107-88e41141adb8",
    OTHERS_REASONS = "288652bc-5b59-4885-98c9-f1d2af4c16a0",
}

export enum BobcardCardVariantEnum {
    ETERNA = "260083e9-5ad6-4e86-9175-571f1ac1c0ad",
    CASHBACK = "91ed927c-0c0a-4a50-a956-b3fa40c3259b",
    TIARA = "a8fd75e8-b6e9-435e-b1e4-b2321f868eb6",
    ETIHAD_GUEST = "4ec2a9be-e356-4cfb-bb52-459fa0a4b75d",
    ETIHAD_GUEST_PREMIUM = "7a1916bc-0e87-4e90-bfb8-fba397c2ad61",
    PREMIER = "885b58f8-a55a-45ca-aa6f-8ababa29205e",
    EASY = "58e7a9e9-57fe-46b5-b5cb-aff155bcef91",
    IRCTC_CREDIT_CARD = "ac53bd54-5bf8-457e-aa33-fac43526fee8",
    SELECT = "4bdca7fc-07f3-4e77-ad9d-e6e7647eeffe",
    CORPORATE = "36689459-3a26-4058-ae78-9adccf23ddad",
    EMPOWER = "97d8d7ce-754f-4e4d-906d-01e992eb2e0d",
    PRIME = "8fea171f-f211-4c81-9fb6-21e1763b25da",
    HPCL_ENERGIE = "a8179573-00c6-43a4-9435-01568f0ee448",
}

export enum BobcardEventContainerEmploymentStatusEnum {
    SALARIED = "add0e913-aed5-4575-ac5a-5c63c4cf2239",
    SELF_EMPLOYED = "dcf88701-1595-4ca1-9be0-56c7adfa37ab",
}

export enum BobcardEventContainerGenderEnum {
    MALE = "8951a16f-858e-4b9f-9439-249debcf824f",
    FEMALE = "529f30c7-59b0-4146-8d21-935b2d06feb3",
}

export enum BobcardEventContainerMaritalStatusEnum {
    UNMARRIED = "2f555a9b-8521-4bf6-8547-f6e7d4ba2f2e",
    MARRIED = "28d3436d-c74e-4456-961f-67ad71cc5fc7",
    DIVORCED = "d3a6a871-5f1b-4aa3-9476-27a107e16a1f",
}

export enum BobcardEventContainerCardNetworkEnum {
    VISA = "470d72a8-dc8f-49e1-b716-06b00342d96c",
    MASTERCARD = "0c8352bc-0576-410b-8145-6e96adaf96ea",
    RUPAY = "cb98fc47-3485-4a73-abba-a75910cb12cc",
}

export enum BobcardEventContainerYesNoEnum {
    YES = "4b1f2181-5662-4ce3-88f3-55965ec96e0f",
    NO = "f3e15be8-105d-49b4-9e28-2e1b96f91bcc",
}

export enum BobcardEnquiryDigitalLeadStatusEnum {
    NEW = "b8986c21-9f4a-4846-af38-b311c04af9b6",
    DUPLICATE = "51fe9a27-6420-4303-9da9-2acc3feecaf6",
    RETURN = "270b1744-275d-47b5-8eb4-d9f4dc4c6f56",
}

export enum BobcardEnquiryDispositionEnum {
    OPEN = "72a0579d-b691-41f8-a393-910d89a0f347",
}

export const bobcardGenders: Record<BobcardGenderEnum, {id: Uuid; displayName: string}> = {
    [BobcardGenderEnum.MALE]: {
        id: BobcardGenderEnum.MALE as Uuid,
        displayName: "Male",
    },
    [BobcardGenderEnum.FEMALE]: {
        id: BobcardGenderEnum.FEMALE as Uuid,
        displayName: "Female",
    },
    [BobcardGenderEnum.OTHER]: {
        id: BobcardGenderEnum.OTHER as Uuid,
        displayName: "Other",
    },
};

/**
 * Journey disposition tree (L1–L4). Display names encode the full path for reporting and UI.
 */
export const bobcardEventContainerDispositions: Record<
    BobcardEventContainerDispositionEnum,
    {
        id: Uuid;
        displayName: string;
        flatDisposition: string;
    }
> = {
    [BobcardEventContainerDispositionEnum.NEW_LEAD]: {
        id: "1c998660-58b3-49d4-b361-493885d22196" as Uuid,
        displayName: "New Lead",
        flatDisposition: "new-lead",
    },
    [BobcardEventContainerDispositionEnum.NOT_CONNECTED_NOT_REACHABLE]: {
        id: "94318eb5-3eae-45cb-bcdd-0da3fef3f237" as Uuid,
        displayName: "Not Connected · Not Reachable",
        flatDisposition: "not-connected_not-reachable",
    },
    [BobcardEventContainerDispositionEnum.NOT_CONNECTED_DEAD_LEAD]: {
        id: "742c5560-3346-4c2f-82f3-73c999439d59" as Uuid,
        displayName: "Not Connected · Dead Lead",
        flatDisposition: "not-connected_dead-lead",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_NEEDS_INFO_BENEFITS]: {
        id: "102d2473-2a44-4644-b4bd-8b1df70d73b6" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Needs More Info — Benefits",
        flatDisposition: "connected_valid_interested_needs-info_benefits",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_NEEDS_INFO_FEES]: {
        id: "57c5f83a-54f9-40cb-ac2f-f394c8235be5" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Needs More Info — Fees & Charges",
        flatDisposition: "connected_valid_interested_needs-info_fees-charges",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_NEEDS_INFO_ELIGIBILITY]: {
        id: "b6182e0b-e4e6-4de9-89c9-65ff1597dc39" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Needs More Info — Eligibility",
        flatDisposition: "connected_valid_interested_needs-info_eligibility",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_VIDEO_KYC_PENDING]: {
        id: "88d98137-3247-4199-817f-e3670fe4453b" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Video KYC Pending",
        flatDisposition: "connected_valid_interested_video-kyc-pending",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_DIGILOCKER_PENDING]: {
        id: "3de7d3c9-e14a-4a7e-b00f-0808c366b8ee" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Digilocker Step Pending",
        flatDisposition: "connected_valid_interested_digilocker-pending",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_NOT_ELIGIBLE_FOR_CARD]: {
        id: "c51787ba-25fc-4e2e-9af9-cb83718d8ecb" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Not Eligible for Card Applied",
        flatDisposition: "connected_valid_interested_not-eligible-card",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_READY_TO_APPLY]: {
        id: "7284851c-2a3d-44d2-ace2-610759380200" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Ready to Apply Now",
        flatDisposition: "connected_valid_interested_ready-to-apply",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_OTHER]: {
        id: "e382a5b8-f38c-4b5a-9cc9-7d767637f605" as Uuid,
        displayName: "Connected · Valid Lead · Interested · Other",
        flatDisposition: "connected_valid_interested_other",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_SAME_BANK_CARD]: {
        id: "566cff4e-71cf-4f1d-9bcb-7f9740cd6d85" as Uuid,
        displayName: "Connected · Valid Lead · Not Interested · Already Has Card (Same Bank)",
        flatDisposition: "connected_valid_not-interested_same-bank-card",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_OTHER_BANK_CARD]: {
        id: "5dc71c51-14db-4804-89a6-6af939f6e8ae" as Uuid,
        displayName: "Connected · Valid Lead · Not Interested · Already Has Card (Other Bank)",
        flatDisposition: "connected_valid_not-interested_other-bank-card",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_NO_CREDIT_CARD]: {
        id: "634c8405-0afe-4b2e-8d08-7ca2e73dc919" as Uuid,
        displayName: "Connected · Valid Lead · Not Interested · Does Not Want Credit Card",
        flatDisposition: "connected_valid_not-interested_no-credit-card",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_TOO_MANY_CALLS]: {
        id: "d68bb8cd-8a49-4256-95d5-7fbcf1752b13" as Uuid,
        displayName: "Connected · Valid Lead · Not Interested · Too Many Promotional Calls",
        flatDisposition: "connected_valid_not-interested_too-many-calls",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_BAD_EXPERIENCE]: {
        id: "6a2023f3-ca44-4e39-98a5-fbf4190b7c1b" as Uuid,
        displayName: "Connected · Valid Lead · Not Interested · Bad Experience with Bank/Card",
        flatDisposition: "connected_valid_not-interested_bad-experience",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_FEES_CONCERN]: {
        id: "4cdaf478-ad44-4aa3-aaaa-d1f1cd48d5f7" as Uuid,
        displayName: "Connected · Valid Lead · Not Interested · Concern About Fees/Charges",
        flatDisposition: "connected_valid_not-interested_fees-concern",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER]: {
        id: "a29ddaf3-bbe4-45bf-b9c5-66f059632c9b" as Uuid,
        displayName: "Connected · Call Back Later (1)",
        flatDisposition: "connected_call-back-later-1",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_INVALID_DID_NOT_FILL_DEAD_LEAD]: {
        id: "820657c0-dae7-41b7-9178-c77c297aa7c3" as Uuid,
        displayName: "Connected · Invalid Lead · Did Not Fill · Dead Lead",
        flatDisposition: "connected_invalid_did-not-fill_dead-lead",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_INVALID_DID_NOT_FILL]: {
        id: "71c8085f-4853-43f5-89f6-ee8465769655" as Uuid,
        displayName: "Connected · Invalid Lead · Did Not Fill",
        flatDisposition: "connected_invalid_did-not-fill",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_INVALID_FILLED_BY_MISTAKE_DEAD_LEAD]: {
        id: "0f08d565-f848-407c-811a-7e49e76026c2" as Uuid,
        displayName: "Connected · Invalid Lead · Filled By Mistake · Dead Lead",
        flatDisposition: "connected_invalid_filled-by-mistake_dead-lead",
    },
    [BobcardEventContainerDispositionEnum.CONNECTED_INVALID_FILLED_BY_MISTAKE]: {
        id: "8d090a27-9e21-497e-935e-f5cb76ee1176" as Uuid,
        displayName: "Connected · Invalid Lead · Filled By Mistake",
        flatDisposition: "connected_invalid_filled-by-mistake",
    },
    [BobcardEventContainerDispositionEnum.WRONG_NUMBER]: {
        id: "c2e2441e-3953-438c-b615-6a04ba1f5cc9" as Uuid,
        displayName: "Wrong Number",
        flatDisposition: "wrong-number",
    },
};

export const getBobcardEventContainerDispositions = () =>
    Object.values(bobcardEventContainerDispositions).map((d) => ({
        id: d.id,
        displayName: d.flatDisposition,
    }));

/** Lead lifecycle status (Live / Churned / Archive). */
export const bobcardEventContainerStatuses: Record<
    BobcardEventContainerStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEventContainerStatusEnum.LIVE]: {
        id: BobcardEventContainerStatusEnum.LIVE as Uuid,
        displayName: "Live",
    },
    [BobcardEventContainerStatusEnum.CHURNED]: {
        id: BobcardEventContainerStatusEnum.CHURNED as Uuid,
        displayName: "Churned",
    },
    [BobcardEventContainerStatusEnum.ARCHIVE]: {
        id: BobcardEventContainerStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

export const getBobcardEventContainerStatuses = () => Object.values(bobcardEventContainerStatuses);

export const bobcardApplicationStatuses: Record<
    BobcardApplicationStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardApplicationStatusEnum.NOT_STARTED]: {
        id: BobcardApplicationStatusEnum.NOT_STARTED as Uuid,
        displayName: "Not Started",
    },
    [BobcardApplicationStatusEnum.IN_PROGRESS]: {
        id: BobcardApplicationStatusEnum.IN_PROGRESS as Uuid,
        displayName: "In Progress",
    },
    [BobcardApplicationStatusEnum.ON_HOLD]: {
        id: BobcardApplicationStatusEnum.ON_HOLD as Uuid,
        displayName: "On Hold",
    },
    [BobcardApplicationStatusEnum.REJECTED]: {
        id: BobcardApplicationStatusEnum.REJECTED as Uuid,
        displayName: "Rejected",
    },
    [BobcardApplicationStatusEnum.ONBOARDED]: {
        id: BobcardApplicationStatusEnum.ONBOARDED as Uuid,
        displayName: "Onboarded",
    },
    [BobcardApplicationStatusEnum.CHURNED]: {
        id: BobcardApplicationStatusEnum.CHURNED as Uuid,
        displayName: "Churned",
    },
};

export const getBobcardApplicationStatuses = () => Object.values(bobcardApplicationStatuses);

/** Option IDs stored on journey `BOBCARD__EVENT_CONTAINER__APPLICATION_STAGE__COLUMN_ID` (Issuance CRM stages). */
export const bobcardApplicationStages: Record<
    BobcardApplicationStageEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardApplicationStageEnum.CARD_APPROVED]: {
        id: BobcardApplicationStageEnum.CARD_APPROVED as Uuid,
        displayName: "CARD_APPROVED",
    },
    [BobcardApplicationStageEnum.CARD_CONFIGURATION]: {
        id: BobcardApplicationStageEnum.CARD_CONFIGURATION as Uuid,
        displayName: "CARD_CONFIGURATION",
    },
    [BobcardApplicationStageEnum.APPLICATION_REJECTED]: {
        id: BobcardApplicationStageEnum.APPLICATION_REJECTED as Uuid,
        displayName: "APPLICATION_REJECTED",
    },
    [BobcardApplicationStageEnum.APPLICATION_APPROVED]: {
        id: BobcardApplicationStageEnum.APPLICATION_APPROVED as Uuid,
        displayName: "APPLICATION_APPROVED",
    },
    [BobcardApplicationStageEnum.APPLICATION_HOLD]: {
        id: BobcardApplicationStageEnum.APPLICATION_HOLD as Uuid,
        displayName: "APPLICATION_HOLD",
    },
    [BobcardApplicationStageEnum.CAF_PERSONAL_DETAILS]: {
        id: BobcardApplicationStageEnum.CAF_PERSONAL_DETAILS as Uuid,
        displayName: "CAF_PERSONAL_DETAILS",
    },
    [BobcardApplicationStageEnum.CAF_EMAIL]: {
        id: BobcardApplicationStageEnum.CAF_EMAIL as Uuid,
        displayName: "CAF_EMAIL",
    },
    [BobcardApplicationStageEnum.CUSTOMER_DEDUPE]: {
        id: BobcardApplicationStageEnum.CUSTOMER_DEDUPE as Uuid,
        displayName: "CUSTOMER_DEDUPE",
    },
    [BobcardApplicationStageEnum.PROGRAM_CONSENTS]: {
        id: BobcardApplicationStageEnum.PROGRAM_CONSENTS as Uuid,
        displayName: "PROGRAM_CONSENTS",
    },
    [BobcardApplicationStageEnum.PAN_VALIDATION]: {
        id: BobcardApplicationStageEnum.PAN_VALIDATION as Uuid,
        displayName: "PAN_VALIDATION",
    },
    [BobcardApplicationStageEnum.PAN_VERIFY_SUCCESS]: {
        id: BobcardApplicationStageEnum.PAN_VERIFY_SUCCESS as Uuid,
        displayName: "PAN_VERIFY_SUCCESS",
    },
    [BobcardApplicationStageEnum.AADHAAR_VALIDATION]: {
        id: BobcardApplicationStageEnum.AADHAAR_VALIDATION as Uuid,
        displayName: "AADHAAR_VALIDATION",
    },
    [BobcardApplicationStageEnum.RE_AADHAAR_VALIDATION]: {
        id: BobcardApplicationStageEnum.RE_AADHAAR_VALIDATION as Uuid,
        displayName: "RE_AADHAAR_VALIDATION",
    },
    [BobcardApplicationStageEnum.AADHAAR_VERIFY_SUCCESS]: {
        id: BobcardApplicationStageEnum.AADHAAR_VERIFY_SUCCESS as Uuid,
        displayName: "AADHAAR_VERIFY_SUCCESS",
    },
    [BobcardApplicationStageEnum.CAF_PERMANENT_ADDRESS]: {
        id: BobcardApplicationStageEnum.CAF_PERMANENT_ADDRESS as Uuid,
        displayName: "CAF_PERMANENT_ADDRESS",
    },
    [BobcardApplicationStageEnum.CAF_CURRENT_ADDRESS]: {
        id: BobcardApplicationStageEnum.CAF_CURRENT_ADDRESS as Uuid,
        displayName: "CAF_CURRENT_ADDRESS",
    },
    [BobcardApplicationStageEnum.CAF_ADDITIONAL_DETAILS]: {
        id: BobcardApplicationStageEnum.CAF_ADDITIONAL_DETAILS as Uuid,
        displayName: "CAF_ADDITIONAL_DETAILS",
    },
    [BobcardApplicationStageEnum.CAF_MOBILE_NUMBER]: {
        id: BobcardApplicationStageEnum.CAF_MOBILE_NUMBER as Uuid,
        displayName: "CAF_MOBILE_NUMBER",
    },
    [BobcardApplicationStageEnum.UPDATE_BULK_ADDRESS]: {
        id: BobcardApplicationStageEnum.UPDATE_BULK_ADDRESS as Uuid,
        displayName: "UPDATE_BULK_ADDRESS",
    },
    [BobcardApplicationStageEnum.LIMIT_ENHANCEMENT]: {
        id: BobcardApplicationStageEnum.LIMIT_ENHANCEMENT as Uuid,
        displayName: "LIMIT_ENHANCEMENT",
    },
    [BobcardApplicationStageEnum.LIMIT_ENHANCEMENT_AA]: {
        id: BobcardApplicationStageEnum.LIMIT_ENHANCEMENT_AA as Uuid,
        displayName: "LIMIT_ENHANCEMENT_AA",
    },
    [BobcardApplicationStageEnum.EMPLOYER_ADDRESS]: {
        id: BobcardApplicationStageEnum.EMPLOYER_ADDRESS as Uuid,
        displayName: "EMPLOYER_ADDRESS",
    },
    [BobcardApplicationStageEnum.UNDERWRITING]: {
        id: BobcardApplicationStageEnum.UNDERWRITING as Uuid,
        displayName: "UNDERWRITING",
    },
    [BobcardApplicationStageEnum.AA_UNDERWRITING]: {
        id: BobcardApplicationStageEnum.AA_UNDERWRITING as Uuid,
        displayName: "AA_UNDERWRITING",
    },
    [BobcardApplicationStageEnum.FETCH_CREDIT_BUREAU]: {
        id: BobcardApplicationStageEnum.FETCH_CREDIT_BUREAU as Uuid,
        displayName: "FETCH_CREDIT_BUREAU",
    },
    [BobcardApplicationStageEnum.ACCOUNT_AGGREGATOR]: {
        id: BobcardApplicationStageEnum.ACCOUNT_AGGREGATOR as Uuid,
        displayName: "ACCOUNT_AGGREGATOR",
    },
    [BobcardApplicationStageEnum.OFFER_CREATED]: {
        id: BobcardApplicationStageEnum.OFFER_CREATED as Uuid,
        displayName: "OFFER_CREATED",
    },
    [BobcardApplicationStageEnum.CARD_SELECTION]: {
        id: BobcardApplicationStageEnum.CARD_SELECTION as Uuid,
        displayName: "CARD_SELECTION",
    },
    [BobcardApplicationStageEnum.CARD_DETAILS]: {
        id: BobcardApplicationStageEnum.CARD_DETAILS as Uuid,
        displayName: "CARD_DETAILS",
    },
    [BobcardApplicationStageEnum.VIDEO_KYC]: {
        id: BobcardApplicationStageEnum.VIDEO_KYC as Uuid,
        displayName: "VIDEO_KYC",
    },
    [BobcardApplicationStageEnum.E_SIGN_CONSENT_COMPLETED]: {
        id: BobcardApplicationStageEnum.E_SIGN_CONSENT_COMPLETED as Uuid,
        displayName: "E_SIGN_CONSENT_COMPLETED",
    },
    [BobcardApplicationStageEnum.GENERATE_CAF_DOCUMENT]: {
        id: BobcardApplicationStageEnum.GENERATE_CAF_DOCUMENT as Uuid,
        displayName: "GENERATE_CAF_DOCUMENT",
    },
    [BobcardApplicationStageEnum.AGREEMENT_SIGNED]: {
        id: BobcardApplicationStageEnum.AGREEMENT_SIGNED as Uuid,
        displayName: "AGREEMENT_SIGNED",
    },
    [BobcardApplicationStageEnum.E_SIGN_AGREEMENT]: {
        id: BobcardApplicationStageEnum.E_SIGN_AGREEMENT as Uuid,
        displayName: "E_SIGN_AGREEMENT",
    },
    [BobcardApplicationStageEnum.E_SIGN_CONSENT]: {
        id: BobcardApplicationStageEnum.E_SIGN_CONSENT as Uuid,
        displayName: "E_SIGN_CONSENT",
    },
    [BobcardApplicationStageEnum.VKYC_FINAL_VERIFICATION]: {
        id: BobcardApplicationStageEnum.VKYC_FINAL_VERIFICATION as Uuid,
        displayName: "VKYC_FINAL_VERIFICATION",
    },
    [BobcardApplicationStageEnum.LP_LEAD_CREATED]: {
        id: BobcardApplicationStageEnum.LP_LEAD_CREATED as Uuid,
        displayName: "LP_LEAD_CREATED",
    },
    [BobcardApplicationStageEnum.LP_OTP_VERIFIED]: {
        id: BobcardApplicationStageEnum.LP_OTP_VERIFIED as Uuid,
        displayName: "LP_OTP_VERIFIED",
    },
};

export const getBobcardApplicationStageSelectOptions = () => Object.values(bobcardApplicationStages);

/** Option IDs for journey `BOBCARD__EVENT_CONTAINER__REJECTION_STAGE__COLUMN_ID`. */
export const bobcardRejectionStages: Record<
    BobcardRejectionStageEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardRejectionStageEnum.DEDUPE_FAILED]: {
        id: BobcardRejectionStageEnum.DEDUPE_FAILED as Uuid,
        displayName: "DEDUPE_FAILED",
    },
    [BobcardRejectionStageEnum.INITIAL_REJECT]: {
        id: BobcardRejectionStageEnum.INITIAL_REJECT as Uuid,
        displayName: "Initial Reject",
    },
    [BobcardRejectionStageEnum.PAN_VERIFICATION_REJECT]: {
        id: BobcardRejectionStageEnum.PAN_VERIFICATION_REJECT as Uuid,
        displayName: "PAN Verification Reject",
    },
    [BobcardRejectionStageEnum.AADHAR_VERIFICATION_REJECT]: {
        id: BobcardRejectionStageEnum.AADHAR_VERIFICATION_REJECT as Uuid,
        displayName: "AADHAR Verification Reject",
    },
    [BobcardRejectionStageEnum.UNDERWRITING_REJECT]: {
        id: BobcardRejectionStageEnum.UNDERWRITING_REJECT as Uuid,
        displayName: "Underwriting Reject",
    },
    [BobcardRejectionStageEnum.VKYC_REJECT]: {
        id: BobcardRejectionStageEnum.VKYC_REJECT as Uuid,
        displayName: "VKYC Reject",
    },
    [BobcardRejectionStageEnum.CARD_ISSUANCE_PRECHECK]: {
        id: BobcardRejectionStageEnum.CARD_ISSUANCE_PRECHECK as Uuid,
        displayName: "Card Issuance Precheck",
    },
    [BobcardRejectionStageEnum.OTHERS_REASONS]: {
        id: BobcardRejectionStageEnum.OTHERS_REASONS as Uuid,
        displayName: "Others Reasons",
    },
};

export const getBobcardRejectionStageSelectOptions = () => Object.values(bobcardRejectionStages);

/** Shared option IDs for Interested / Selected Card Variant journey columns. */
export const bobcardCardVariants: Record<
    BobcardCardVariantEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardCardVariantEnum.ETERNA]: {
        id: BobcardCardVariantEnum.ETERNA as Uuid,
        displayName: "ETERNA",
    },
    [BobcardCardVariantEnum.CASHBACK]: {
        id: BobcardCardVariantEnum.CASHBACK as Uuid,
        displayName: "CASHBACK",
    },
    [BobcardCardVariantEnum.TIARA]: {
        id: BobcardCardVariantEnum.TIARA as Uuid,
        displayName: "TIARA",
    },
    [BobcardCardVariantEnum.ETIHAD_GUEST]: {
        id: BobcardCardVariantEnum.ETIHAD_GUEST as Uuid,
        displayName: "ETIHAD GUEST",
    },
    [BobcardCardVariantEnum.ETIHAD_GUEST_PREMIUM]: {
        id: BobcardCardVariantEnum.ETIHAD_GUEST_PREMIUM as Uuid,
        displayName: "ETIHAD GUEST PREMIUM",
    },
    [BobcardCardVariantEnum.PREMIER]: {
        id: BobcardCardVariantEnum.PREMIER as Uuid,
        displayName: "PREMIER",
    },
    [BobcardCardVariantEnum.EASY]: {
        id: BobcardCardVariantEnum.EASY as Uuid,
        displayName: "EASY",
    },
    [BobcardCardVariantEnum.IRCTC_CREDIT_CARD]: {
        id: BobcardCardVariantEnum.IRCTC_CREDIT_CARD as Uuid,
        displayName: "IRCTC Credit Card",
    },
    [BobcardCardVariantEnum.SELECT]: {
        id: BobcardCardVariantEnum.SELECT as Uuid,
        displayName: "SELECT",
    },
    [BobcardCardVariantEnum.CORPORATE]: {
        id: BobcardCardVariantEnum.CORPORATE as Uuid,
        displayName: "CORPORATE",
    },
    [BobcardCardVariantEnum.EMPOWER]: {
        id: BobcardCardVariantEnum.EMPOWER as Uuid,
        displayName: "EMPOWER",
    },
    [BobcardCardVariantEnum.PRIME]: {
        id: BobcardCardVariantEnum.PRIME as Uuid,
        displayName: "PRIME",
    },
    [BobcardCardVariantEnum.HPCL_ENERGIE]: {
        id: BobcardCardVariantEnum.HPCL_ENERGIE as Uuid,
        displayName: "HPCL ENERGIE",
    },
};

export const getBobcardCardVariantSelectOptions = () => Object.values(bobcardCardVariants);

/** Option IDs for journey `BOBCARD__EVENT_CONTAINER__EMPLOYMENT_STATUS__COLUMN_ID`. */
export const bobcardEventContainerEmploymentStatuses: Record<
    BobcardEventContainerEmploymentStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEventContainerEmploymentStatusEnum.SALARIED]: {
        id: BobcardEventContainerEmploymentStatusEnum.SALARIED as Uuid,
        displayName: "Salaried",
    },
    [BobcardEventContainerEmploymentStatusEnum.SELF_EMPLOYED]: {
        id: BobcardEventContainerEmploymentStatusEnum.SELF_EMPLOYED as Uuid,
        displayName: "Self-employed",
    },
};

export const getBobcardEventContainerEmploymentStatusSelectOptions = () => Object.values(bobcardEventContainerEmploymentStatuses);

/** Option IDs for journey `BOBCARD__EVENT_CONTAINER__GENDER__COLUMN_ID` (lead / journey; distinct from user profile gender). */
export const bobcardEventContainerGenders: Record<
    BobcardEventContainerGenderEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEventContainerGenderEnum.MALE]: {
        id: BobcardEventContainerGenderEnum.MALE as Uuid,
        displayName: "Male",
    },
    [BobcardEventContainerGenderEnum.FEMALE]: {
        id: BobcardEventContainerGenderEnum.FEMALE as Uuid,
        displayName: "Female",
    },
};

export const getBobcardEventContainerGenderSelectOptions = () => Object.values(bobcardEventContainerGenders);

/** Option IDs for journey `BOBCARD__EVENT_CONTAINER__MARITAL_STATUS__COLUMN_ID`. */
export const bobcardEventContainerMaritalStatuses: Record<
    BobcardEventContainerMaritalStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEventContainerMaritalStatusEnum.UNMARRIED]: {
        id: BobcardEventContainerMaritalStatusEnum.UNMARRIED as Uuid,
        displayName: "Unmarried",
    },
    [BobcardEventContainerMaritalStatusEnum.MARRIED]: {
        id: BobcardEventContainerMaritalStatusEnum.MARRIED as Uuid,
        displayName: "Married",
    },
    [BobcardEventContainerMaritalStatusEnum.DIVORCED]: {
        id: BobcardEventContainerMaritalStatusEnum.DIVORCED as Uuid,
        displayName: "Divorced",
    },
};

export const getBobcardEventContainerMaritalStatusSelectOptions = () => Object.values(bobcardEventContainerMaritalStatuses);

/** Option IDs for journey `BOBCARD__EVENT_CONTAINER__NETWORK_SELECTED__COLUMN_ID`. */
export const bobcardEventContainerCardNetworks: Record<
    BobcardEventContainerCardNetworkEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEventContainerCardNetworkEnum.VISA]: {
        id: BobcardEventContainerCardNetworkEnum.VISA as Uuid,
        displayName: "Visa",
    },
    [BobcardEventContainerCardNetworkEnum.MASTERCARD]: {
        id: BobcardEventContainerCardNetworkEnum.MASTERCARD as Uuid,
        displayName: "Mastercard",
    },
    [BobcardEventContainerCardNetworkEnum.RUPAY]: {
        id: BobcardEventContainerCardNetworkEnum.RUPAY as Uuid,
        displayName: "Rupay",
    },
};

export const getBobcardEventContainerNetworkSelectedSelectOptions = () => Object.values(bobcardEventContainerCardNetworks);

/**
 * Shared Yes/No option IDs for journey boolean-style columns (PAN Validation, Aadhar Verification,
 * E-Consent, V-KYC Successful, UPI Linkage).
 */
export const bobcardEventContainerYesNoOptions: Record<
    BobcardEventContainerYesNoEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEventContainerYesNoEnum.YES]: {
        id: BobcardEventContainerYesNoEnum.YES as Uuid,
        displayName: "Yes",
    },
    [BobcardEventContainerYesNoEnum.NO]: {
        id: BobcardEventContainerYesNoEnum.NO as Uuid,
        displayName: "No",
    },
};

export const getBobcardEventContainerYesNoSelectOptions = () => Object.values(bobcardEventContainerYesNoOptions);

/** Enquiry digital lead status (New / Duplicate / Return). */
export const bobcardEnquiryDigitalLeadStatuses: Record<
    BobcardEnquiryDigitalLeadStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEnquiryDigitalLeadStatusEnum.NEW]: {
        id: BobcardEnquiryDigitalLeadStatusEnum.NEW as Uuid,
        displayName: "New",
    },
    [BobcardEnquiryDigitalLeadStatusEnum.DUPLICATE]: {
        id: BobcardEnquiryDigitalLeadStatusEnum.DUPLICATE as Uuid,
        displayName: "Duplicate",
    },
    [BobcardEnquiryDigitalLeadStatusEnum.RETURN]: {
        id: BobcardEnquiryDigitalLeadStatusEnum.RETURN as Uuid,
        displayName: "Return",
    },
};

export const getBobcardEnquiryDigitalLeadStatuses = () => Object.values(bobcardEnquiryDigitalLeadStatuses);

/** Single template disposition for enquiry events (ingest-only; status lives on Digital Lead Status column). */
export const bobcardEnquiryDispositions: Record<
    BobcardEnquiryDispositionEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEnquiryDispositionEnum.OPEN]: {
        id: BobcardEnquiryDispositionEnum.OPEN as Uuid,
        displayName: "Open",
    },
};

export const getBobcardEnquiryDispositions = () => Object.values(bobcardEnquiryDispositions);
